import classNames from "classnames/bind";
import React from "react";
import styles from "./ProgressBar.module.scss";
import type { ProgressBarProps } from "./types";

const cx = classNames.bind(styles);

const ProgressBar = React.forwardRef<HTMLDivElement, ProgressBarProps>(
  (
    {
      value = 0,
      max = 100,
      label,
      showAnimation = false,
      intent = "neutral",
      className,
      ...props
    }: ProgressBarProps,
    forwardedRef
  ) => {
    const safeValue = Math.min(max, Math.max(value, 0));

    return (
      <div
        ref={forwardedRef}
        className={cx("container", className)}
        {...props}
      >
        <div
          className={cx("bar", intent)}
          aria-label="progress bar"
          aria-valuenow={value}
          aria-valuemax={max}
        >
          <div
            className={cx("bar-fill", {
              "has-animation": showAnimation,
            })}
            style={{
              width: max ? `${(safeValue / max) * 100}%` : `${safeValue}%`,
            }}
          />
        </div>
        {label ? <span className={cx("label")}>{label}</span> : null}
      </div>
    );
  }
);

ProgressBar.displayName = "ProgressBar";

export default ProgressBar;
